<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="section-header">
          <h2>Landing Page</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <textarea
          class="form-control"
          type="text"
          rows="10"
          step="any"
          name="levy"
          v-model="someCode"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" style="border:1px solid black; border-radius:15px;">
        <div class="no-style" v-html="someCode"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  data() {
    return {
      htmlCode: "",
      someCode: ""
    };
  },
  async mounted() {
    this.htmlCode = localStorage.getItem("htmlPreview");
    console.log(this.$route.params.html);
  }
};
</script>

<style lang="scss" scoped></style>
